@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';

.deactivation-modal-text {
  text-align: left;
  padding: @space-0;
  color: var(--default--text-color--9);
}

.deactivation-modal-header {
  width: auto;
  height: 48px;
  padding: @space-8 @space-16;
  border-radius: 4px 4px 0 0;
  gap: 164px;
  display: flex;
  align-items: center;
  color: var(--default--text-color--9);
}

.deactivate-modal-body {
  width: 673px;
  height: auto;
  border: 1px 0 0 0;
  gap: @space-8;
  text-align: left;
}

.deactivate-modal-content {
  color: var(--default--modal--text-color--1);
  padding: @space-16;

  .deactivation-body-text {
    padding-bottom: @space-8;
    color: var(--default--text-color--17);
  }

  .confirmation {
    padding-bottom: @space-8;
    color: var(--default--text-color--9);
  }
}

.divider {
  border-bottom: 1px solid var(--table--border-color--2);
}

.deactivate-modal-buttons {
  display: flex;
  padding: @space-16;
  justify-content: flex-end;

  .cancel-button {
    width: 61px;
    height: 32px;
    margin-right: @space-16;
  }
}
